function typeOf(obj) {
    let typeList = {
        '[object Boolean]'  : 'boolean',
        '[object Number]'   : 'number',
        '[object String]'   : 'string',
        '[object Function]' : 'function',
        '[object Array]'    : 'array',
        '[object Date]'     : 'date',
        '[object RegExp]'   : 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]'     : 'null',
        '[object Object]'   : 'object'
    };
    return typeList[Object.prototype.toString.call(obj)];
}

const EventProxy = {
    onObj: {},

    // 订阅者监听事件，on 可以监听一个事件的多个方法，且可触发多次
    on: function (key, ...rest) {
        if(this.onObj[key] === undefined) {
            this.onObj[key] = []
        }

        // rest是伪数组
        for (let i = 0; i < rest.length; i++) {
            if (typeOf(rest[i]) !== 'function') {
                throw new Error('eventProxy.on期望注入的是function类型')
            }
            this.onObj[key].push(rest[i])
        }
    },

    // 解除所有订阅了某个事件的所有函数
    off: function (key) {
        this.onObj[key] = [];
    },

    // 发布者发布事件，触发on进行订阅函数
    emit: function (key, ...data) {
        if (this.onObj[key] !== undefined && this.onObj[key].length > 0) {
            this.onObj[key].forEach(item => {
                item.call(null, ...data)
            })
        }
    }
}

export default EventProxy
